export const AM_TOURS_AND_TRAVELS = 6614
export const ASHWINI_TOURS_AND_TRAVELS = 6441
export const BHARAT_TOURIST = 432
export const BLUE_BIRD = 6098
export const BOXONGO_COMPANY_ID = 5719
export const CLASSIC_BUS = 6660
export const DASHMESH = 4755
export const DEMO_COMPANY = 1
export const DEUBEY_JS = 4442
export const DUBEY_TRAVEL = 3871
export const GOLINK = 6595
export const GT_COMPANY_ID = 10
export const GUJRAT_COMPANY_ID = 10
export const HANDA_COMPANY_ID = 90
export const HANS_COMPANY_ID = 11
export const INTERCITY = 471
export const JAIN_BABA = 2921
export const JAIN_COMPANY_ID = 805
export const JAIN_GANGANANGAR = 2650
export const JAIN_GUDIA = 184
export const JAIN_NEW = 66
export const JAIN_PARSHWANTH = 1190
export const JAIN_UDAIPUR = 2649
export const JAISHREE = 1591
export const KHAJURAHO = 2956
export const LAXMI_HOLIDAYS = 5054
export const LEYMA_CARGO = 6583
export const MAHAVEER = 84
export const MANORAMA = 5094
export const MODI_PARAS = 303
export const MY_BUS = 3855
export const NARMADA_TRAVELS = 6607
export const POORNIMA = 5702
export const RAJ_SHILA = 5049
export const RAJDEEP = 1852
export const RAJESH_TRANSPORT = 6763
export const RAMTOURS = 1181
export const RAMTTRAVEL_PUNE = 6393
export const RISHABH_COMPANY_ID = 28
export const RM_LOGISTICS = 6167
export const ROYAL_TRAVELS = 105
export const SAINI_TRAVELS = 15
export const SAMAY_TRAVEL = 918
export const SANJAY_INDORE = 425
export const SANGITAM_TRAVEL = 6378
export const SHAHYADRI = 6064
export const SHATABDI_BANSWARA = 1020
export const SHREE_LAXMI_YATRA = 2245
export const SHRI_BABU = 1695
export const SIDDHI_VINAYAK = 322
export const SRJ_LOGISTICS = 6545
export const SS_CARRIERS = 5530
export const STA_COMPANY_ID = 406
export const TEJAS= 4007
export const VIJAYVARGIYA_CARGO = 5181
export const VISHWA_COMPANY_ID = 301
export const STA_RAJKOT_OFFLINE_BRANCH_ID = 82831
export const DNR = 2435
export const GAJRAJ = 3032
export const PAYAL = 1543
export const HANS_BRANCH_ID = 21
export const KANKAR_ROADWAYS = 3398
export const L_K_TRAVELS = 664